import React from 'react';
import { Modal } from './Modal';
import { Button } from '../primitives/Button';
import { Icon } from '../primitives/Icon';

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  message?: string | React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'primary' | 'warning';
  loading?: boolean;
}

const VARIANT_STYLES = {
  danger:  { icon: 'warning',   bg: 'bg-red-100',    color: 'text-red-600' },
  warning: { icon: 'warning',   bg: 'bg-amber-100',  color: 'text-amber-600' },
  primary: { icon: 'help',      bg: 'bg-primary/10', color: 'text-primary' },
};

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'אישור',
  cancelLabel = 'ביטול',
  variant = 'primary',
  loading,
}) => {
  const v = VARIANT_STYLES[variant];
  const buttonVariant = variant === 'danger' ? 'danger' : 'primary';

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      showCloseButton={false}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={buttonVariant} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="flex gap-4">
        <div className={`size-12 rounded-full ${v.bg} ${v.color} flex items-center justify-center flex-shrink-0`}>
          <Icon name={v.icon} size={24} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-bold text-slate-900 dark:text-white mb-1">{title}</h3>
          {message && <div className="text-sm text-slate-600 dark:text-slate-400">{message}</div>}
        </div>
      </div>
    </Modal>
  );
};
